<template>
  <div v-if="video" class="space-y-4">
    <div class="flex items-center justify-between">
      <h2>{{ video.title }}</h2>
      <div class="flex items-center gap-4">
        <CVButton
          v-if="$can('delete', 'Video')"
          variant="danger"
          size="icon"
          @click="emit('delete')"
          ><TrashIcon class="h-4 w-4"
        /></CVButton>
        <CVButton
          v-if="$can('update', 'Video')"
          variant="secondary"
          size="icon"
          @click="emit('edit')"
          ><PencilIcon class="h-4 w-4"
        /></CVButton>
      </div>
    </div>
    <div class="aspect-video w-full overflow-hidden rounded-lg bg-black">
      <video v-if="video.fileUrl" class="h-full w-full" controls>
        <source :src="video.fileUrl" />
      </video>
      <div v-else class="flex h-full w-full items-center justify-center text-white">
        {{ t('videoUrlNotAvailable') }}
      </div>
    </div>
    <div class="whitespace-pre-line text-sm text-obsidian-800">
      {{ video.description }}
    </div>
  </div>
  <div v-else class="flex items-center justify-center">
    <Spinner class="text-hazel-600" />
  </div>
</template>

<script lang="ts" setup>
import CVButton from '@/components/buttons/CVButton.vue';
import Spinner from '@/components/icons/Spinner.vue';
import { useVideo } from '@/queries/use-videos';
import { PencilIcon, TrashIcon } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  videoId: string;
}>();

const emit = defineEmits<{
  (e: 'edit'): void;
  (e: 'delete'): void;
}>();

const { data: video } = useVideo(props.videoId);

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "videoUrlNotAvailable": "Video URL not available.",
    "editVideo": "Edit video"
  },
  "de": {
    "videoUrlNotAvailable": "Video-URL nicht verfügbar.",
    "editVideo": "Video bearbeiten"
  },
  "es": {
    "videoUrlNotAvailable": "URL del vídeo no disponible.",
    "editVideo": "Editar vídeo"
  }
}
</i18n>
